import { render, staticRenderFns } from "./mglory.vue?vue&type=template&id=5e48df7e"
import script from "./mglory.vue?vue&type=script&lang=js"
export * from "./mglory.vue?vue&type=script&lang=js"
import style0 from "./mglory.vue?vue&type=style&index=0&id=5e48df7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports